import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { IAddress } from "@interface/customerDetails/IAddress";
import { addressFormatter } from "@utils/addressFormatter";
import { useStyle } from "@features/customerDetails/style";

interface IParams {
    isAuthenticated: boolean;
    installationAddress?: IAddress;
}

export const CustomerDetailsBroadbandAddress = (props: IParams) => {
    const { isAuthenticated, installationAddress } = props;
    const { t } = useTranslation("customerDetails");
    const { classes } = useStyle();

    return (
        <section>
            <Grid container spacing={2}>
                <Grid item md={8} xs={12}>
                    <Typography color="secondary" variant="h4">
                        {t("gomoBroadbandInstallationAddress")}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography color="secondary" gutterBottom variant="normal">
                        {isAuthenticated ? t("broadbandAddressRegistered") : t("broadbandAddress")}
                    </Typography>
                </Grid>
            </Grid>
            {installationAddress && (
                <div className={classes.address}>
                    <Typography color="primary" variant="normal">
                        {addressFormatter(installationAddress)}
                    </Typography>
                </div>
            )}
        </section>
    );
};
